export default "__VITE_ASSET__DmpVqtgk__"